'use strict'

/**
 * @module toggleFaq
 */


const CLASS_HIDDEN = 'hidden';
const CLASS_HEADER = 'js-toggle-faq'

export default {
    /**
     * @description Initialise toggleFaq
     * @returns {undefined}
     */
    init() {
        this.bind()
    },

    /**
     * @description Bind events on toggleFaq elements
     * @returns {undefined}
     */
    bind() {
        document.getElementsByClassName(CLASS_HEADER)
            .bindEvent('click', this.activeTarget);
    },

    activeTarget(e) {
        e.preventDefault()
        const trigger = e.currentTarget.nextSibling
        const status = !trigger.classList.contains(CLASS_HIDDEN)

        if (status) {
            trigger.classList.add(CLASS_HIDDEN)
        } else {
            trigger.classList.remove(CLASS_HIDDEN)
        }
    }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/toggleFaq.js